export class AppError extends Error {
    status: number;
    errorCode?: string;
    displayMessage?: string;
    details?: any;

    constructor(errInfo: { message: string, status?: number, errorCode?: string, displayMessage?: string, details?: any }) {
        super();
        const { status, errorCode, message, displayMessage, details } = errInfo;
        this.message = message;
        this.status = status || 500;
        this.errorCode = errorCode;
        this.displayMessage = displayMessage;
        this.details = details;
        this.toString = () => `${status}${errorCode ? '/'+errorCode : ''}: ${message}`;
    }
}
